// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___VzDyf","grid":"grid___xlH1X","with_header":"with_header___BXuun","header":"header___zmgli","tile":"tile___B6RUb"};